import { Button } from 'aimo-ui';
import {
  FooterButtonContainer,
  VerticalDistributedContainer,
} from 'components/sheets/SheetLayout';
import { format } from 'date-fns';
import useReadPurchasedPrepaidTickets from 'hooks/useReadPurchasedPrepaidTickets';
import useSelectedParkingVehicle from 'hooks/useSelectedParkingVehicle';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PredefinedTicket } from 'types/generatedSchemaTypes';
import { getLocale } from 'utils/commonUtils';
import { testIdentifiers } from 'utils/testIdentifiers';
import PaymentCardDropDown from './PaymentCardDropDown';
import StartParkingButton from './StartParkingButton';
import VehicleSelectDropDown from './VehicleSelectDropDown';

const PrepaidActiveButton = ({ permitActive }: { permitActive: boolean }) => {
  const { purchasedPrepaidTickets, loading } = useReadPurchasedPrepaidTickets(
    {}
  );
  const selectedVehicle = useSelectedParkingVehicle();
  const prepaidTicketsValidUntil = useMemo(
    () =>
      purchasedPrepaidTickets
        ?.filter(
          (ticket) =>
            ticket?.accessDevice?.value ===
            selectedVehicle?.licensePlate.plateText
        )
        .reduce<PredefinedTicket | undefined>(
          (a, b) => {
            if (a?.endTime && b?.endTime) {
              return a.endTime > b.endTime ? a : b;
            } else if (!a || (a && !a.endTime)) {
              return b;
            } else {
              return a;
            }
          },
          { sessionType: 'PREPAID', type: 'FIXED_DURATION' }
        ),
    [purchasedPrepaidTickets, selectedVehicle]
  );
  const prepaidSession = purchasedPrepaidTickets?.[0];
  const { t } = useTranslation();

  // When no prepaid for selected vehicle or still loading, show full footer so user can change vehicle/card and Park
  if (!prepaidSession || loading) {
    return <StartParkingButton />;
  }

  const dateFormat = prepaidTicketsValidUntil?.endTime
    ? format(
        new Date(prepaidTicketsValidUntil.endTime as string),
        'dd.MM.yyyy HH:mm',
        {
          locale: getLocale(),
        }
      )
    : '';
  const endDateText = t('button.prepaidUntil', { dateTime: dateFormat });

  return (
    <FooterButtonContainer pb={10}>
      <VerticalDistributedContainer>
        <FooterButtonContainer pb={0}>
          <VehicleSelectDropDown />
          <PaymentCardDropDown />
        </FooterButtonContainer>
        <Button
          {...testIdentifiers('prepaid-active-button')}
          size="l"
          text={permitActive ? t('button.permitActive') : endDateText}
          disabled={true}
          buttonType="tertiary"
        />
      </VerticalDistributedContainer>
    </FooterButtonContainer>
  );
};

export default PrepaidActiveButton;
